<!--
 * @message: 
 * @Author: Betway<848032671@qq.com>
 * @Github: github
 * @Date: 2020-06-30 13:25:51
 * @FilePath: \mrc-ess-fronted\src\Page\EssAdmin\Attendance\InternalUse\Attendance.vue
 * @最后编辑: Betway
 * @最后修改时间: 2022-04-07 15:07:32
 -->
<template>
  <ContentLayout
    :title="$t('label_essweb_attendanceInternal_list_title')"
    pad="0"
    @activated="activated"
    filterable
    @filter="
      (val) => {
        filterPageData = val;
      }
    "
  >
    <template v-slot:nav-actions>
      <v-tooltip
        bottom
        v-if="hasBtn('unlock-admin-internal-attendance-record')"
      >
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            class="mr-2 text-capitalize primary"
            color="white"
            :loading="lockloading"
            v-bind="attrs"
            v-on="on"
            icon
            @click="batchLock(0)"
          >
            <i class="material-icons-round">lock_open</i>
          </v-btn>
        </template>
        <span>{{
          $t("message_essweb_attendanceRecord_list_tools_batchUnLockTip")
        }}</span>
      </v-tooltip>
      <v-tooltip bottom v-if="hasBtn('lock-admin-internal-attendance-record')">
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            class="mr-2 text-capitalize primary"
            color="white"
            icon
            v-bind="attrs"
            v-on="on"
            :loading="lockloading2"
            @click="batchLock(1)"
          >
            <i class="material-icons-round">lock</i>
          </v-btn>
        </template>
        <span>{{
          $t("message_essweb_attendanceRecord_list_tools_batchLockTip")
        }}</span>
      </v-tooltip>
    </template>
    <!-- 筛选 -->
    <template v-slot:top-selection="{ filter }">
      <Selections2
        @close="filterable = !filterable"
        :objects="filterObjects"
        small-chip
        @filter="
          filter();
          toFilter(1, filter);
        "
        @update="
          (prop, value, selected) => {
            $fliterValue(filterObjects, prop, value, selected);
          }
        "
        @reset="
          (apply) => {
            $fliterValue(filterObjects, null, null);
            if (apply) {
              filter();
              toFilter(1, filter);
            }
          }
        "
      />
    </template>
    <!-- content -->
    <template v-slot:page-main>
      <Tabler
        :headers="headers"
        :items="desserts"
        @select="onSelect"
        :defaultSelect="selected"
        :showSelect="showSelect && !isLoading"
        :height="$vuetify.breakpoint.height - 275 - 48"
        :totalCount="totalCount"
        :filter-page-data="filterPageData"
        @change="
          (page, perpage, callback, data) => {
            getList(data, page, perpage, callback);
          }
        "
        overLoading
      >
        <template v-slot:item.staffid="{ item }">
          <div style="max-width: 300px">
            <v-list-item dense two-line class="pa-0 ma-0">
              <v-list-item-avatar size="36" class="mr-1 my-0 pa-0">
                <StaffAvatar
                  size="36"
                  :isTemp="item.is_temp"
                  :src="item.staff_avatar"
                  :staff_name="item.preferred_name"
                />
              </v-list-item-avatar>
              <v-list-item-content>
                <v-list-item-title
                  >{{ $getCommonLangValue(item.preferred_name) }}
                  <span class="text--secondary text-caption-xs">
                    {{ item.staff_code }}</span
                  ></v-list-item-title
                >
                <v-list-item-subtitle>{{
                  $getCommonLangValue(item.job_post_name)
                }}</v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
          </div>
        </template>
        <template v-slot:item.date="{ item }">
          <div class="text--primary table-title">
            {{ $getDateTime(item.utc_att_date, "YYYY/MM/DD") }}
          </div>
        </template>
        <template v-slot:item.name="{ item }">
          <div class="text--primary table-title">
            {{ $getCommonLangValue(item.official_shift_name) }}
          </div>
        </template>
        <template v-slot:item.startTime="{ item }">
          <div class="text--primary table-title">
            {{ $getDateTime(item.official_start_utc_time, "HH:mm") }}
          </div>
          <div class="text--secondary table-subtitle">
            {{ $getUtcByCode(item.official_start_time_zone) }}
          </div>
        </template>
        <template v-slot:item.endTime="{ item }">
          <div class="text--primary table-title">
            {{ $getDateTime(item.official_end_utc_time, "HH:mm") }}
          </div>
          <div class="text--secondary table-subtitle">
            {{ $getUtcByCode(item.official_end_time_zone) }}
          </div>
        </template>
        <template v-slot:item.punchInTime="{ item }">
          <div class="text--primary table-title">
            {{ $getDateTime(item.official_punch_in_utc_datetime, "HH:mm") }}
          </div>
          <div class="text--secondary table-subtitle">
            {{ $getUtcByCode(item.official_punch_in_time_zone) }}
          </div>
        </template>
        <template v-slot:item.punchOutTime="{ item }">
          <div class="text--primary table-title">
            {{ $getDateTime(item.official_punch_out_utc_datetime, "HH:mm") }}
          </div>
          <div class="text--secondary table-subtitle">
            {{ $getUtcByCode(item.official_punch_out_time_zone) }}
          </div>
        </template>
        <template v-slot:item.tag="{ item }">
          <div style="max-width: 200px" class="d-flex flex-wrap justify-start">
            <v-chip
              small
              v-if="Number(item.is_late)"
              :color="$getTagColors($card_line_colors, 'is_late_1')"
              class="ma-1 white--text"
              >{{ $t("label_essweb_system_tag_label_lateLabel") }}({{
                item.official_total_late_minutes || 0
              }}
              {{ $t("label_essweb_system_minutesLabel") }})</v-chip
            >
            <v-chip
              small
              v-if="Number(item.is_ot)"
              :color="$getTagColors($card_line_colors, 'is_ot_1')"
              class="ma-1 white--text"
              >{{ $t("label_essweb_system_tag_label_otLabel") }}({{
                item.official_total_ot_minutes || 0
              }}
              {{ $t("label_essweb_system_minutesLabel") }})</v-chip
            >
            <v-chip
              small
              v-if="Number(item.is_early_leave)"
              :color="$getTagColors($card_line_colors, 'is_early_leave_1')"
              class="ma-1 white--text"
              >{{ $t("label_essweb_system_tag_label_earlyLeaveLabel") }}({{
                item.official_total_early_leave_minutes || 0
              }}
              {{ $t("label_essweb_system_minutesLabel") }})</v-chip
            >
            <v-chip
              small
              v-if="Number(item.is_absense)"
              :color="$getTagColors($card_line_colors, 'is_absense_1')"
              class="ma-1 white--text"
              >{{ $t("label_essweb_system_tag_label_absenseLabel") }}</v-chip
            >
            <v-chip
              small
              v-if="Number(item.is_work_from_home)"
              :color="$getTagColors($card_line_colors, 'is_work_from_home_1')"
              class="ma-1 text--primary"
              >{{
                $t("label_essweb_punchRecord_list_tag_workFromHomeLabbel")
              }}</v-chip
            >
            <v-chip
              small
              v-if="Number(item.is_locked)"
              :color="$getTagColors($card_line_colors, 'is_locked_1')"
              class="ma-1 white--text"
              >{{ $t("label_essweb_system_tag_label_isLockedLabel") }}</v-chip
            >
            <v-chip
              small
              v-if="Number(item.is_adhoc)"
              :color="$getTagColors($card_line_colors, 'is_adhoc_1')"
              class="ma-1 text--primary"
              >{{ $t("label_essweb_system_tag_label_isAdhocLabel") }}</v-chip
            >
            <v-chip
              small
              v-if="Number(item.is_missing_punch)"
              :color="$getTagColors($card_line_colors, 'is_missing_punch_1')"
              class="ma-1 white--text"
              >{{
                $t("label_essweb_system_tag_label_isMissingPunchLabel")
              }}</v-chip
            >
            <v-chip
              small
              v-if="Number(item.is_out_of_office)"
              :color="$getTagColors($card_line_colors, 'is_out_of_office_1')"
              class="ma-1 text--primary"
              >{{
                $t("label_essweb_system_tag_label_isOutOfOfficeLabel")
              }}</v-chip
            >
            <v-chip
              small
              v-if="Number(item.is_onDuty)"
              :color="$getTagColors($card_line_colors, 'is_on_duty_1')"
              class="ma-1 white--text"
              >{{ $t("label_essweb_system_tag_label_isOnDutyLabel") }}</v-chip
            >
            <v-chip
              small
              outlined
              :color="leave.color_code"
              v-for="(leave, index) in item.leave_info"
              :key="`leave--${index}`"
              class="ma-1"
              >{{ $getCommonLangValue(leave["leave_type_name"]) }}</v-chip
            >
            <v-chip
              small
              :color="$getTagColors($card_line_colors, 'is_holiday_1')"
              v-for="(holiday, index) in item.holiday_info"
              :key="`holiday--${index}`"
              class="ma-1 text--primary"
              >{{ $getCommonLangValue(holiday["holiday_name"]) }}</v-chip
            >
          </div>
        </template>
        <template v-slot:item.workMinute="{ item }"
          >{{ item.official_working_minutes || 0
          }}{{ $t("label_essweb_system_minutesLabel") }}</template
        >
        <template v-slot:item.status="{ item }">
          <div style="max-width: 20px">
            <svg-icon
              size="18"
              :fill="Number(item.is_onduty) ? 'green' : 'rgb(228, 228, 228)'"
              iconClass="LabeledColour"
            />
          </div>
        </template>
        <template v-slot:item.action="{ item }">
          <!-- <v-btn icon @click="toView(item.uuid)">
            <svg-icon
                  size="24"
                  fill="currentColor"
                  iconClass="viewDetail"
                />
          </v-btn> -->
          <!-- 2021-08-17 内部记录可修改排班考勤 -->
          <tableListTools
            :uuid="item.uuid"
            :viewBtn="hasBtn('change-admin-internal-shift')"
            :otherBtn="hasBtn('apply-admin-internal-leave')"
            otherText="label_essweb_attendanceInternal_toApplyLeaveLabel"
            editText="label_essweb_attendanceInternal_list_tools_changeAttendanceLabel"
            viewText="label_essweb_attendanceInternal_list_tools_changeShiftLabel"
            :editBtn="hasBtn('change-admin-internal-attendance')"
            :title="$t('label_essweb_attendanceInternal_list_title')"
            @view="toShift(item, $getDateTime(item.utc_att_date, 'YYYY-MM-DD'))"
            @edit="
              toAttendance(item, $getDateTime(item.utc_att_date, 'YYYY-MM-DD'))
            "
            @other="toApply(item.staff_uuid)"
          />
        </template>
      </Tabler>
    </template>
    <!-- content -->
    <!-- tools -->
    <template v-slot:tools-main>
      <ShiftDialog
        :show="showShift"
        @close="
          showShift = false;
          nowShow = false;
          curData = null;
        "
        @onChange="controlNav"
        :curData="curData"
        @onSubmit="
          showShift = false;
          nowShow = false;
          curData = null;
          toFilter(null, () => {});
        "
      />
      <attendanceDialog
        :show="showAttendance"
        @close="
          showAttendance = false;
          nowShow2 = false;
          Roster_uuid = null;
          curData2 = null;
        "
        @onChange="controlNav2"
        :curUuid="Roster_uuid"
        :curData="curData2"
        @onSubmit="
          showAttendance = false;
          nowShow2 = false;
          Roster_uuid = null;
          curData2 = null;
          toFilter(null, () => {});
        "
      />
    </template>
    <!-- tools -->
  </ContentLayout>
</template>

<script>
import ShiftDialog from "@/Page/EssAdmin/Attendance/InternalUse/components/shiftDialog.vue";
import attendanceDialog from "@/Page/EssAdmin/Attendance/InternalUse/components/attendanceDialog.vue";
import { mapGetters } from "vuex";
export default {
  name: "AttendanceInteruse",
  components: { ShiftDialog, attendanceDialog },
  computed: {
    ...mapGetters(["isLoading"]),
  },
  data() {
    return {
      showShift: false,
      showAttendance: false,
      nowShow: false,
      Roster_uuid: null,
      nowShow2: false,
      showSelect: true,
      selected: [],
      curData: null,
      page: null,
      filterPageData: null,
      pagesize: null,
      curData2: null,
      search: "",
      filterable: false,
      totalCount: 0,
      headers: [
        {
          text: "label_essweb_attendanceInternal_list_staffIdLabel",
          value: "staffid",
          align: "start",
          sortable: false,
        },
        {
          text: "label_essweb_attendanceInternal_list_dateLabel",
          value: "date",
          align: "start",
          sortable: false,
        },
        {
          text: "label_essweb_attendanceInternal_list_officialShiftLabel",
          value: "name",
          align: "start",
          sortable: false,
          filter: (value, search, item) => {
            if (!this.search) return true;
            return (
              item.schedule_shift_name
                .toString()
                .toLocaleUpperCase()
                .indexOf(this.search.toLocaleUpperCase()) != -1 ||
              item.official_shift_name
                .toString()
                .toLocaleUpperCase()
                .indexOf(this.search.toLocaleUpperCase()) != -1
            );
          },
        },
        {
          text: "label_essweb_attendanceInternal_list_officialStartTitmeLabel",
          value: "startTime",
          align: "center",
          sortable: false,
        },
        {
          text: "label_essweb_attendanceInternal_list_officialEndTimeLabel",
          value: "endTime",
          align: "center",
          sortable: false,
        },
        {
          text: "label_essweb_attendanceInternal_list_officialPunchInTimeLabel",
          value: "punchInTime",
          align: "center",
          sortable: false,
        },
        {
          text: "label_essweb_attendanceInternal_list_officialPunchOutTimeLabel",
          value: "punchOutTime",
          align: "center",
          sortable: false,
        },
        {
          text: "label_essweb_attendanceInternal_list_officialWorkingMinutesLabel",
          value: "workMinute",
          align: "start",
          sortable: false,
        },
        {
          text: "label_essweb_attendanceInternal_list_tagLabel",
          value: "tag",
          align: "start",
          sortable: false,
        },
        {
          text: "label_essweb_attendanceInternal_list_onDutyLabel",
          value: "status",
          width: 50,
          align: "center",
          sortable: false,
        },
        {
          text: "label_essweb_list_components_tools_actionLabel",
          value: "action",
          align: "end",
          sortable: false,
        },
      ],
      lockloading: false,
      lockloading2: false,
      desserts: [],
      filterObjects: [
        {
          type: "select",
          sequence: 0,
          position: "right",
          showKey: "preferred_name",
          subKey: "job_post_name",
          name: "staff",
          multiple: true,
          avatar: true,
          twoLine: true,
          label: "label_essweb_attendanceRecord_list_staffLabel",
          value: [],

          selected: [],
          data: {
            api: "all_staff",
            url_type: "all_staff",
            args: null,
            table: "mrbase_sys_staffs",
            type: "",
            modelKey: "staff_code",
            valueKey: "staff_id",
            global: false,
          },
        },
        {
          type: "month",
          sequence: 1,
          name: "date",
          position: "right",
          label: "label_essweb_attendanceRecord_list_dateLabel",
          value: "",
          data: {
            api: "",
            max: "",
            min: "",
            args: {},
          },
        },
        {
          type: "select",
          sequence: 2,
          position: "right",
          showKey: "shift_name",
          name: "shift",
          multiple: true,
          label: "label_essweb_attendanceRecord_list_officialShiftLabel",
          value: [],
          selected: [],
          data: {
            api: "/attendance-master/get-shift-select/",
            url_type: "primary",
            args: null,
            table: "ess_att_attendance_master",
            type: "",
            modelKey: "shift_name",
            valueKey: "uuid",
            global: false,
          },
        },
        {
          type: "select",
          sequence: 3,
          position: "right",
          showKey: "dict_label",
          name: "tag",
          multiple: true,
          label: "label_essweb_approvalProcess_list_statusLabel",
          value: [],
          selected: [],
          data: {
            api: "/attendance-master/get-tag-select/",
            url_type: "primary",
            args: null,
            table: "ess_att_attendance_master",
            type: "",
            modelKey: "dict_label",
            valueKey: "dict_value",
            global: false,
          },
        },
        {
          type: "select",
          sequence: 4,
          position: "right",
          showKey: "dict_label",
          name: "staff_status",
          disabled: false,
          multiple: true,
          label: "label_essweb_UM_filters_jobStatusLabel",
          value: [],
          selected: [],
          data: {
            api: "/dictionary/list-dictionary-byname/",
            url_type: "primary",
            args: { dict_name: "staffStatus" },
            table: "mrbase_sys_dict",
            type: "lang",
            modelKey: "dict_label",
            valueKey: "dict_value",
            global: false,
          },
        },
      ],
    };
  },
  mounted() {
    this.getBtnPermissionList();
    this.getList(null, 1, this.$tableSetting.perPageSize, null);
  },
  methods: {
    activated(refresh) {
      const that = this;
      if (refresh == 0) {
        this.filterable = false;
        this.$fliterValue(this.filterObjects, null, null);
        // if (this.page !== null) {
        this.desserts = [];
        this.getList(null, 1, this.$tableSetting.perPageSize, () => {
          that.$store.dispatch("resetTable", new Date().getTime());
        });
        // }
      }
      if (refresh == 1) {
        if (this.page !== null) {
          this.toFilter(null, () => {});
        } else {
          this.toFilter(1, () => {
            that.$store.dispatch("resetTable", new Date().getTime());
          });
        }
      }
    },
    toApply(staff) {
      this.$toPage(
        "/admin/attendance-internal/attendance-internal-leave-application/" +
          this.$aesEncrypt(JSON.stringify({ staff_uuid: staff }))
      );
    },
    batchLock(lock) {
      const that = this;
      if (this.selected.length == 0) return;
      let uuids = [];
      this.selected.map((item) => {
        uuids.push(item.uuid);
      });
      lock ? (this.lockloading2 = true) : (this.lockloading = true);
      let url = lock
        ? "/attendance-master/batch-lock/"
        : "/attendance-master/batch-unlock/";
      this.$Request({
        method: "POST",
        table: "ess_att_attendance_master",
        url: url,
        data: { uuids: uuids.join(",") },
      }).then((res) => {
        that.$showMessage({
          type: "success",
          text: lock
            ? that.$t(
                "message_essweb_attendanceRecord_list_batchLockSuccessLabel"
              )
            : that.$t(
                "message_essweb_attendanceRecord_list_batchUnLockSuccessLabel"
              ),
        });
        that.getList(null, 1, that.$tableSetting.perPageSize, () => {
          that.$store.dispatch("resetTable", new Date().getTime());
        });
      });
    },
    onSelect(items) {
      this.selected = items;
    },
    toShift: function (curdata, date) {
      this.curData = curdata;
      this.curData["roster_date"] = date;
      this.showShift = true;
    },
    toAttendance(curdata, date) {
      this.Roster_uuid = curdata.uuid;
      this.curData2 = curdata;
      this.curData2["roster_date"] = date;
      this.showAttendance = true;
    },
    controlNav: function (f) {
      if (!this.nowShow) {
        this.nowShow = true;
      } else {
        this.nowShow = false;
        this.showShift = false;
        this.curData = null;
      }
    },
    controlNav2: function (f) {
      if (!this.nowShow2) {
        this.nowShow2 = true;
      } else {
        this.nowShow2 = false;
        this.showAttendance = false;
        this.curData2 = null;
        this.Roster_uuid = null;
      }
    },
    toFilter(tab, callback) {
      const that = this;
      let object = [];
      object = this.filterObjects.filter((ele) =>
        Object.prototype.toString.call(ele["value"]).toLowerCase() ===
        "[object array]"
          ? ele["value"].length
          : ele.value !== undefined && ele.value != ""
      );
      let data = {};
      object.map((item) => {
        if (item["name"] == "staff")
          data["staff_uuid"] = item.value ? item.value.join(",") : "";
        if (item["name"] == "date")
          data["month"] = item.value ? item.value.replace("-", "") : "";
        if (item["name"] == "shift")
          data["shift_uuid"] = item.value ? item.value.join(",") : "";
        if (item["name"] == "tag") {
          data["tags"] = item.value.join(",");
        }
        if (item["name"] == "staff_status")
          data["staff_status"] = item.value ? item.value.join(",") : "";
      });
      if (tab) {
        this.getList(data, 1, this.$tableSetting.perPageSize, callback);
      } else {
        this.getList(
          data,
          this.page ? this.page : 1,
          this.pagesize ? this.pagesize : this.$tableSetting.perPageSize,
          callback
        );
      }
    },
    getList: function (data, page, perpage, callback) {
      const that = this;
      if (page !== 1) this.page = page;
      else this.page = null;
      if (perpage !== this.$tableSetting.perPageSize) this.pagesize = perpage;
      else this.pagesize = null;
      this.selected = [];
      this.lockloading2 = false;
      this.lockloading = false;
      if (data) {
        data["cpage"] = page;
        data["pagesize"] = perpage;
      }
      this.$Request({
        method: "POST",
        table: "ess_att_attendance_master",
        url: "/attendance-master/get-list/",
        data: data ? data : { cpage: page, pagesize: perpage },
      })
        .then((res) => {
          that.desserts = res.data;
          that.totalCount = res.totalcount;
          callback ? callback(page, perpage, data) : null;
        })
        .catch(() => {
          callback ? callback(page, perpage, data) : null;
        });
    },

    toView: function (uuid) {
      this.$toPage("/admin/attendance/detail/" + uuid);
    },
    toEditAll: function () {
      this.showSelect = !this.showSelect;
    },
  },
};
</script>